/* eslint-disable sort-keys-fix/sort-keys-fix */
import React from 'react';
import * as R from 'ramda';
import { Box, Typography } from '@mui/material';
import SwiftDispatchLogo from 'assets/img/dashboard-swift-dispatch-logo.svg';
import MagellanLogo from 'assets/img/dashboard-magellan-logo.svg';
import ContactsIcon from '@mui/icons-material/Contacts';
import ArtTrackIcon from '@mui/icons-material/ArtTrackRounded';
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import SmallModuleButton from 'common/SmallModuleButton';
import { Link } from 'react-router-dom';
import { useUserRolePermissions } from 'hooks';
import Flag from 'common/FeatureFlags/Flag';
import packageJson from '../../../../package.json';

const DispatchingDashboard = () => {
  const { currentAffiliate } = useUserRolePermissions();

  // icons for dispatching dashboard
  const buttons = [
    {
      disabled: false,
      icon: <ArtTrackIcon fontSize="inherit" />,
      label: 'Trailer Compliance',
      loading: R.isNil(currentAffiliate),
      to: 'compliance/trailer-status',
    },
    {
      disabled: false,
      icon: <ContactsIcon fontSize="inherit" />,
      label: 'Driver Compliance',
      loading: R.isNil(currentAffiliate),
      to: 'compliance/driver-status',
    },
  ];

  return (
    <Box
      sx={{
        alignItems: 'center',
        display: 'flex',
        flexDirection: 'column',
        height: { xs: 'initial', sm: '100vh' },
        justifyContent: 'space-between',
        pb: 6,
        pt: 7,
        px: 2,
      }}
    >
      <Box
        sx={{
          alignItems: 'center',
          display: 'flex',
          flex: '1 0',
          justifyContent: 'center',
          mx: 0,
          my: 2,
        }}
      >
        <Link to="../..">
          <img alt="Swift" src={SwiftDispatchLogo} />
        </Link>
      </Box>
      <Box
        sx={{
          alignSelf: 'center',
          display: 'grid',
          gridGap: { xs: 'initial', sm: 8 },
          gridTemplateColumns: { xs: 'repeat(2, 1fr)', sm: 'repeat(3, 1fr)' },
          gridTemplateRows: { xs: 'repeat(3, 1fr)', sm: 'repeat(2, 1fr)' },
          padding: '80px',
        }}
      >
        <Flag value={process.env.REACT_APP_LD_DISPATCHING_LOADS}>
          <SmallModuleButton
            disabled={false}
            icon={<LocalShippingIcon fontSize="inherit" />}
            key="Loads"
            label="Loads"
            loading={R.isNil(currentAffiliate)}
            to="loads"
          />
        </Flag>
        {buttons.map(
          ({ label, hide, ...rest }) =>
            !hide && <SmallModuleButton key={label} label={label} {...rest} />
        )}
      </Box>
      <Box
        sx={{
          alignItems: 'flex-end',
          display: 'flex',
          flex: '1 0',
          justifyContent: 'center',
          mx: 0,
          my: 2,
        }}
      >
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            flexDirection: 'column',
          }}
        >
          <img
            alt="Magellan Midstream Partners, L.P."
            src={MagellanLogo}
            style={{ marginBottom: '24px' }}
          />
          <Typography align="center" sx={{ mb: 3 }} variant="caption">
            Version {packageJson.version}
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};

export default DispatchingDashboard;
